import { AppConfig } from "../AppConfig";
import { ErrorCode, ErrorDetails } from "../Common/Types";
import { RequestInitWithRetry } from "fetch-retry";
import { AUTHORIZATION_SCHEME, fetchWithRetry, wrapWithErrorHandling } from "./baseApi";
import { Api, HttpResponse, SalesItemResponseDto } from "./generatedProductCatalogApi";

export class ProductCatalogApi {
  private readonly productCatalogClient;

  public constructor() {
    const token: string | null = sessionStorage.getItem(AppConfig.sessionStorageKeys.jwtToken);
    if (token == null) {
      throw new ErrorDetails({
        code: ErrorCode.AuthenticationFailed,
        details: { additionalDetails: "Authentication token is missing. Please log in." },
      });
    }
    this.productCatalogClient = new Api({
      baseUrl: `${AppConfig.api.productCatalogApi}`,
      securityWorker: () => {
        return {
          headers: {
            Authorization: `${AUTHORIZATION_SCHEME} ${token}`,
          },
        };
      },
      customFetch: (input: string | URL | globalThis.Request, init?: RequestInit) => {
        const withRetryParams: RequestInitWithRetry<typeof global.fetch> = init ?? {};
        withRetryParams.retries = 3;
        withRetryParams.retryDelay = function (attempt) {
          return Math.pow(2, attempt) * 1000;
        };
        return fetchWithRetry(input, withRetryParams);
      },
    });
  }

  public async getPayInFullDiscount(
    market: string,
    program: string,
    currency: string,
    brochure: string,
    season: string,
    destination: string = "ALL"
  ): Promise<SalesItemResponseDto | undefined> {
    return await wrapWithErrorHandling<SalesItemResponseDto, HttpResponse<SalesItemResponseDto, void>>(
      ErrorCode.Skip,
      () =>
        this.productCatalogClient.api.salesItemsGetSkuV3(`DIPIF-${destination}`, {
          Market: market,
          Program: program,
          Currency: currency,
          Brochure: brochure,
          Season: season,
          IncludeSystemArticle: true,
        })
    );
  }
}
